import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// Single source of truth for category -> visual language, shared by the
// admin CRUD table (SetupManagement/DashboardMessages) and the runtime
// banner/modal/card/toast components, so both surfaces stay in sync.
// Each category carries a two-stop gradient pair (not just a flat accent)
// so every surface — icon badge, wash background, glow shadow — reads as
// deliberately colorful rather than a single muted tint.
export const CATEGORY_META = {
  new_module: {
    label: "New Feature",
    accent: "#14b8a6",
    accentDark: "#0d9488",
    Icon: AutoAwesomeOutlinedIcon,
  },
  change_notice: {
    label: "Change Notice",
    accent: "#f59e0b",
    accentDark: "#d97706",
    Icon: AutorenewOutlinedIcon,
  },
  advertisement: {
    label: "Did You Know",
    accent: "#a855f7",
    accentDark: "#7c3aed",
    Icon: CampaignOutlinedIcon,
  },
  maintenance: {
    label: "Maintenance",
    accent: "#fb923c",
    accentDark: "#ea580c",
    Icon: ConstructionOutlinedIcon,
  },
  general: {
    label: "Announcement",
    accent: "#3b82f6",
    accentDark: "#2563eb",
    Icon: InfoOutlinedIcon,
  },
};

export const getCategoryMeta = (category) =>
  CATEGORY_META[category] || CATEGORY_META.general;

// Diagonal two-stop wash, used as the background for badges/cards/banners so
// each category reads as a distinct block of color rather than a thin tint.
export const getCategoryGradient = (meta, isDark) =>
  `linear-gradient(135deg, ${meta.accent} 0%, ${meta.accentDark} 100%)`;

// Soft background wash (for card/banner surfaces that still need to host
// readable body text) plus a matching glow shadow, tuned per theme mode.
export const getCategoryWash = (meta, isDark) =>
  isDark
    ? `linear-gradient(135deg, ${meta.accent}3d 0%, ${meta.accentDark}14 100%)`
    : `linear-gradient(135deg, ${meta.accent}29 0%, ${meta.accentDark}0d 100%)`;

export const getCategoryGlow = (meta, strength = 0.35) =>
  `0 8px 24px ${meta.accent}${Math.round(strength * 255)
    .toString(16)
    .padStart(2, "0")}`;

export const CATEGORY_OPTIONS = Object.entries(CATEGORY_META).map(
  ([value, meta]) => ({ value, label: meta.label }),
);

export const DISPLAY_TYPE_OPTIONS = [
  { value: "banner", label: "Banner (top strip)" },
  { value: "modal", label: "Modal (first-load overlay)" },
  { value: "card", label: "Card (notification feed)" },
  { value: "toast", label: "Toast (bottom-right popup)" },
];

export const CRITICAL_PRIORITY_THRESHOLD = 100;

export const isCriticalPriority = (priority) =>
  Number(priority) >= CRITICAL_PRIORITY_THRESHOLD;
